<ng-select appendTo="{{append}}" [items]="itemsToDisplay" [bindLabel]="labelProperty" [bindValue]="valueProperty"
    [multiple]="false" [placeholder]="placeholder" [clearable]="false" [formControl]="control"
    (change)="onValueChange($event)" [ngClass]="{ 'invalid-field': control.invalid && (submitted || control.touched) }">
</ng-select>
<div *ngIf="control.invalid && (submitted || control.touched)"
    style="font-size: .875rem; color: #dc3545; position: absolute;">
    <div *ngIf="control.errors?.['required']">{{ errorMessage }}</div>
</div>